export const HouseDesginData = [
	{
		name: "Bella",
		value: "Bella",
	},
	{
		name: "Cara",
		value: "Cara",
	},
	{
		name: "Ella",
		value: "Ella",
	},
	{
		name: "Dani",
		value: "Dani",
	},
	{
		name: "Freya",
		value: "Freya",
	},
	{
		name: "Greta",
		value: "Greta",
	},
];

export const InteriorDesign = [
	{
		name: "Bedroom",
		value: "Bedroom",
	},
	{
		name: "Toilet/bath 1st floor",
		value: "Toilet/bath 1st floor",
	},
	{
		name: "Toilet/bath 2nd floor",
		value: "Toilet/bath 2nd floor",
	},
	{
		name: "Kitchen",
		value: "Kitchen",
	},
	{
		name: "Living Area",
		value: "Living Area",
	},
	{
		name: "Dining Area",
		value: "Dining Area",
	},
];

const Sdata = [
	{
		id: 1,
		title: "Recommendation",
		desc: "Supplier can recommend materials for the users for easier navigation.",
		cover: "./images/SlideCard/davies.png",
	},
	{
		id: 2,
		title: "Recommendation",
		desc: "Supplier can recommend materials for the users for easier navigation.",
		cover: "./images/SlideCard/Copy of ss standard JOSE starex hammer ₱125.png",
	},
	{
		id: 3,
		title: "Recommendation",
		desc: "Supplier can recommend materials for the users for easier navigation.",
		cover: "./images/SlideCard/Copy of ii mid utility box ordinary ₱18.png",
	},
	{
		id: 4,
		title: "Recommendation",
		desc: "Supplier can recommend materials for the users for easier navigation.",
		cover: "./images/SlideCard/Copy of ww high brass wood screw size- 6x1 ₱6.00.png",
	},
];
export default Sdata;
